<div class="desktop-cover">
    <h1>Reset password</h1>

    <div class="info" *ngIf="!success">
        <p>Enter your e-mail adress to receive <br/> a link to reset your password</p>
    </div>

    <form name="form" role="form" #resetRequestForm="ngForm" (ngSubmit)="requestReset()">
        <div class="form-group">
            <label for="email">E-mail :</label>
            <input type="email" id="email" name="email" [(ngModel)]="resetAccount.email" class="form-control"
                   placeholder="" minlength=5 maxlength=100 #emailInput="ngModel" required>
        </div>
        <dln-button [type]="'submit'" [isDisabled]="resetRequestForm.form.invalid"
                    [isLoading]="isLoading" [isLoadingLabel]="'Sending request...'"
                    [label]="'Reset'" [icon]="'dln-icon-key'">
        </dln-button>
    </form>

    <dln-alert [type]="'error'" *ngIf="error">{{error}}</dln-alert>

    <dln-alert [type]="'success'" *ngIf="success">
        Check your emails for details on how to reset your password.
    </dln-alert>
</div>
